import React from 'react';
import ReactStars from 'react-stars';

const StarRating = ({ setFieldValue, initialRating, size = 24, name  ,setRating}) => {
  // Define handleChange properly
  const handleChange = (rating) => {
    setRating(rating)
    setFieldValue(name, rating); // Use 'rating' instead of 'newRating'
  };

  return (
    <div>
      <ReactStars
        count={5}
        value={initialRating}
        onChange={handleChange} // onChange will pass 'rating' directly here
        size={size}
        color2={'#ffd700'}
        half={false}
      />
    </div>
  );
};

export default StarRating;
